import { render } from "./ShogunFlyIn.vue?vue&type=template&id=1b700661&scoped=true"
import script from "./ShogunFlyIn.vue?vue&type=script&lang=js"
export * from "./ShogunFlyIn.vue?vue&type=script&lang=js"

import "./ShogunFlyIn.vue?vue&type=style&index=0&id=1b700661&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b700661"]])

export default __exports__